import React from 'react';
import { useI18n } from '~Hooks';
import SettingsToggle, { Setting } from '~Scenes/Handy/Components/SettingsToggle';

const PaymentOptions = () => {
  const { i18n } = useI18n();

  const SETTING_LIST: Setting[] = [
    {
      key: 'enableTipping',
      label: i18n('Handy.EnableTipping'),
    },
    {
      key: 'disableCash',
      label: i18n('Disable.Cash'),
      description: i18n('Disable.Cash.Text'),
    },
    {
      key: 'handyDirectPayment',
      label: i18n('Handy.DirectPayment'),
      description: i18n('Handy.DirectPayment.Text'),
    },
    {
      key: 'enableInvoiceCustomerCreation',
      label: i18n('Settings.EnableInvoiceCustomerCreation'),
      description: i18n('Settings.EnableInvoiceCustomerCreation.Text'),
    },
  ];
  return <SettingsToggle settingList={SETTING_LIST} />;
};

export default PaymentOptions;
